import React, { useCallback, useContext, useState } from "react";
import { INIT_FILTER_STATE } from "../../../../constants/driveglobalfilterinitialstates_coral";
import FilterSecondPageErc_Coral from "./FilterSecondPageErc_Coral";
import TopkpisSecondErc_Coral from "./TopkpisSecondErc_Coral";
import TopkpisSecondMainErc_Coral from "./TopkpisSecondMainErc_Coral";
import WaterMark from "../../DashboardMain_Coral/WaterMark";
import TableMainErc_Coral from "./TableMainErc_Coral";
import RangeSecondErc_Coral from "./RangeSecondErc_Coral";
import NetEnergySecondErc_Coral from "./NetEnergySecondErc_Coral";
import SocDisErc_Coral from "./SocDisErc_Coral";
import DischargeDurErc_Coral from "./DischargeDurErc_Coral";
import CycleVsRange_Coral from "./CycleVsRange_Coral";
import BmsCellTemp_Coral from "./BmsCellTemp_Coral";
import BmsDeltaCellVolt_Coral from "./BmsDeltaCellVolt_Coral";
import McuContTemp_Coral from "./McuContTemp_Coral";
import MotorTempErc_Coral from "./MotorTempErc_Coral";
import DcdcTemp_Coral from "./DcdcTemp_Coral";

function PageSecondErc_Coral(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    VIN_NUM: props.gloablfilter.VIN_NUM.toString(),
    soc_per: props.gloablfilter.SOC,
  });
 

  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);

  return (
    <>
      <FilterSecondPageErc_Coral
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />
      <div className="container-fluid">
        <TopkpisSecondErc_Coral
          gloablfilter={secondPageState}
          apiend="coral_drive_analysis/topkpis_erc"
        />
        <TopkpisSecondMainErc_Coral
          gloablfilter={secondPageState}
          apiend="coral_drive_analysis/topkpismain_erc"
        />
        <section className="graphs">
          <div className="row">
            <div className="col-md-6 col-sm-12 col-lg-3 pr-1 drive_graph">
              <WaterMark />
              <TableMainErc_Coral
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/tabledata_erc"
              ></TableMainErc_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <RangeSecondErc_Coral
                title="Real World Range Distribution"
                
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/bar_chart_erc"
              ></RangeSecondErc_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <NetEnergySecondErc_Coral
                title="Net Energy Consumption"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/bar_chart_erc"
              ></NetEnergySecondErc_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-2">
              <WaterMark />
              <SocDisErc_Coral
                title="SoC Discharge/Cycle"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/bar_chart_erc"
              ></SocDisErc_Coral>
            </div>
          </div>

          <div className="row mt-2 pt-2">
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <DischargeDurErc_Coral
                title="Median Discharge Duration"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/bar_chart_erc"
              ></DischargeDurErc_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <CycleVsRange_Coral
                title="Range Trend Line"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/cycle_vs_range_erc"
              ></CycleVsRange_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <BmsCellTemp_Coral
                title="BMS Max Cell Temperature"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/bms_cell_temp_erc"
              ></BmsCellTemp_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-2">
              <WaterMark />
              <BmsDeltaCellVolt_Coral
                title="BMS Delta Cell Voltage"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/bms_delta_temp_erc"
              ></BmsDeltaCellVolt_Coral>
            </div>
          </div>

          <div className="row mt-2 pt-1">
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-0">
              <WaterMark />
              <McuContTemp_Coral
                title="MCU  Temperature"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/mcu_temp_erc"
              ></McuContTemp_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-0">
              <WaterMark />
              <MotorTempErc_Coral
                title="Motor Temperature"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/motor_temp_erc"
              ></MotorTempErc_Coral>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-1">
              <WaterMark />
              <DcdcTemp_Coral
                title="DCDC Temperature"
                gloablfilter={secondPageState}
                apiend="coral_drive_analysis/dcdc_temp_erc"
              ></DcdcTemp_Coral>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PageSecondErc_Coral;
